import { Reveal, Eyebrow } from "./Reveal";

const PLANS = [
  {
    id: "new",
    label: "New vehicles",
    price: "$1,000",
    unit: "flat fee",
    text: "One fixed fee for the full service — sourcing, negotiation, paperwork, shipping and handover.",
  },
  {
    id: "used",
    label: "Pre-owned vehicles",
    price: "On request",
    unit: "quoted per vehicle",
    text: "Includes travelling to inspect candidate cars in person, assessing condition, and the extra back and forth a used purchase requires.",
  },
];

export const Fees = () => (
  <section id="fees" data-testid="fees-section" className="py-24 md:py-36">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <Eyebrow>Fees</Eyebrow>
        <h2 className="mt-6 max-w-2xl font-display text-4xl font-light leading-tight tracking-tight md:text-5xl">
          One clear fee. No surprises.
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 border-t border-hairline md:grid-cols-2">
        {PLANS.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.1}>
            <div data-testid={`fee-${p.id}`} className={`h-full py-12 md:py-16 ${i === 0 ? "md:pr-16 md:border-r border-hairline" : "md:pl-16 border-t md:border-t-0 border-hairline"}`}>
              <p className="text-[11px] uppercase tracking-[0.28em] text-stone">{p.label}</p>
              <p data-testid={`fee-${p.id}-price`} className="mt-6 font-display text-6xl font-light tracking-tight md:text-7xl">
                {p.price}
              </p>
              <p className="mt-2 text-sm text-mist">{p.unit}</p>
              <p className="mt-8 max-w-sm text-base leading-relaxed text-stone">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
